import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE, setForm,
    setItem,
} from "../../../../redux/actions/generics/IndexedActions";
import { GenericButton } from "../../../../components/buttons/customButtons";
import BigCalendar from "react-big-calendar";
import moment from "moment/moment";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";
import { itineraryService } from "../../../../jwt/_services/eventx/ItineraryService";
import {ActivityItinerary} from "../ActivityItinerary/ActivityItinerary";
import ItineraryCustomModel from "../../../../components/calendar/ItineraryCustomModel";
import EventDatesSection from "../EventDatesSection/EventDatesSection";
import { TT_CLOSE } from "../../../../components/i18n/toolTips";
const localizer = BigCalendar.momentLocalizer(moment);

const ItinerarySection = (props) => {
    const path = props.path + "/itinerary";

    const parentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject, app, udn } = parentState?.data || {};
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [itineraryItems, setItineraryItems] = useState([]);
    const [showItineraryModal, setShowItineraryModal] = useState(true);
    const itineraryModalRef = useRef(null);

    const [openingTime, setOpeningTime] = useState({ hour: 8,  min: 0 });
    const [closingTime, setClosingTime] = useState({ hour: 23,  min: 0 });

    useEffect(()=>{
        if(domainObject?.openingTime && domainObject?.closingTime){
            // Validar formato 00:00 with regex
            if (!/^\d{2}:\d{2}$/.test(domainObject?.openingTime) || !/^\d{2}:\d{2}$/.test(domainObject?.closingTime)) {
                console.log("Invalid time format");
                return;
            }
            const opening = domainObject?.openingTime.split(":");
            const closing = domainObject?.closingTime.split(":");
            setOpeningTime({
                hour: opening[0],
                min: opening[1]
            })
            setClosingTime({
                hour: closing[0],
                min: closing[1]
            })
        }

    }, [domainObject?.openingTime, domainObject?.closingTime])

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);

    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0) return;

        mapItemsToItinerary(listDomainObjects);
    }, [listDomainObjects]);

    useEffect(() => {
        if (!app || !domainObject?.id)
            return;

        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                event: { id: domainObject?.id },
            },
        };

        genericIndexedActions.search(path, itineraryService, 0, 1000, dataRequest);
    }, [domainObject, app]);

    const mapItemsToItinerary = (data) => {

        const items = data.map((item) => {
            const startDateString = `${item.date}T${item.timeStart}`;
            const endDateString = `${item.date}T${item.timeEnd}`;
            return {
                id: item.id,
                title: item.activityName,
                start: new Date(startDateString),
                end: new Date(endDateString),
            };
        });


        setItineraryItems(items);
    };

    const showMenuForm = (item, start, end) => {
        setShowItineraryModal(true);
        itineraryModalRef.current.showModal(item, start, end);
    };

    const onAddItineraryItem = (data) => {
        showMenuForm(null, data.start, data.end);
    };
    const onEditItineraryItem = (_item) => {
        // Busca el item en la lista de items
        const item = listDomainObjects.find((i) => i.id === _item.id);

        setItem(path, item);
        showMenuForm(item);
    };

    const onDeleteItineraryItem = itinerary => genericIndexedActions.delete(path, itineraryService, itinerary?.id, app?.fbDataBase?.id);


    const returnToList = () => {
        props.setItem(props.path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    return (
        <>
            <Card className={"card-modal-big"}>
                {/*{loading && showLoader()}*/}
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-clipboard mr-2"/>
                    {"Itinerario"}
                    <div className="top-right">
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={""}>
                    <div className={"vertical-container media-section-body"}>
                        {loading ? (
                            <Spinner animation="border"/>
                        ) : (
                            <>
                                <EventDatesSection path={props.path} app={props.app} parent={props.parent}/>
                                <br/><br/>
                                <ItineraryCustomModel
                                    path={props.path + "/dates"}
                                    events={itineraryItems}
                                    minHour={openingTime}
                                    maxHour={closingTime}
                                    localizer={localizer}
                                    onSelectEvent={(event) => onEditItineraryItem(event)}
                                    onSelectSlot={onAddItineraryItem}
                                    onDeleteItineraryItem={onDeleteItineraryItem}
                                />
                            </>
                        )}
                    </div>
                </CardBody>
            </Card>
            {showItineraryModal && (
                <ActivityItinerary
                    path={path}
                    parent={domainObject}
                    udn={udn}
                    app={app}
                    ref={itineraryModalRef}
                />
            )}
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
    setItem,
    setForm,

};

export default connect(mapStateToProps, mapActionsToProps)(ItinerarySection);
